<template>
	<div class="sk-nav-link-simple"><button @click="actionGoTo" :class="['sk-navigation-link-simple', { 'sk-navigation-link-simple--active': isActive }]"><span>{{ title }}</span></button></div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'navigation-button',
	props: {
		route: {
			type: String,
			default: null
		},
		routeStartsWith: {
			type: String|Object,
			default: null
		},
		title: {
			type: String,
			default: null
		}
	},
	methods: {
		actionGoTo() {
			this.$root.$emit('navigation-close')
			this.$emit('click')
		}
	},
	computed: {
		isActive() {
			if (this.routeStartsWith) {
				if ('object' === typeof(this.routeStartsWith))
				{
					const cpRoute = Object.assign({ name: '', args: {}}, this.routeStartsWith)
					return this.$route.name.startsWith(cpRoute.name) &&
						Object.getOwnPropertyNames(cpRoute.args)
							.filter(arg =>
								arg in this.$route.params &&
								this.$route.params[arg] === cpRoute.args[arg]
							)
							.length > 0
				}
				return this.$route.name.startsWith(this.routeStartsWith)
			}

			return this.route === this.$route.name
		}
	}
}
</script>

<style scoped>
a > span,
button > span {
	transform: translate(0, 0);
	transition: all 300ms;
	display: inline-block;
}
a:hover > span,
button:hover > span {
	transform: translate(5px, 0);
	text-shadow: var(--main-font-color-invert) 0 0 1px, var(--main-font-color-invert) 0 0 1px;
}
.sk-navigation-link-simple {
	padding-left: 50px;
	padding-right: 50px;
	position: relative;
	color: var(--main-font-color-invert-2);
}
.sk-navigation-link-simple::after {
	content: ' ';
	display: block;
	height: 100%;
	width: 5px;
	background-color: var(--main-color-invert);
	position: absolute;
	top: 0;
	right: 0;
	opacity: 0;
	transition: opacity 0.3s;
}
.sk-navigation-link-simple.sk-navigation-link-simple--active {
	font-weight: 700;
}
.sk-navigation-link-simple.sk-navigation-link-simple--active::after {
	opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavigationButton.vue